.ux-iws-tile {
    &.is-link {
        cursor: pointer;
    }

    &.is-discontinued {
        .ux-tile-head__icon {
            width: 64px;
        }

        .ux-tile-head__text {
            width: calc(100% - 64px);
        }
    }

    uxc-auth-image {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
    }

    ux-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.ux-tile-body__overlay {
    background: rgba(255, 255, 255, 0.9);
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    display: none;
    background: rgba(255, 255, 255, 0.9);
    transition:
        top 0.5s ease,
        opacity 0.5s ease;

    &.is-visible {
        display: block;
    }

    &-close {
        cursor: pointer;
        line-height: 0;
        position: absolute;
        right: 15px;
        top: 15px;

        @media screen and (max-width: 567px) {
            right: 10px;
            top: 10px;
        }
    }

    &-content {
        display: flex;
        flex-direction: column;
        max-width: 270px;
        height: 100%;
        justify-content: center;
        margin: auto;
        text-align: center;

        > div {
            margin-bottom: 10px;
        }

        a {
            background: white;
            margin-bottom: 10px;
        }
    }

    a ux-icon {
        font-size: 24px;
        margin: -5px 0 -5px 10px;
    }
}

.ux-tile-body__button-group {
    a {
        align-items: center;
        display: flex;
        justify-content: center;
        position: relative;
    }

    .ux-button--icon-only ux-icon {
        font-size: 20px;
        height: 20px;
        margin: 0;
        transform: none;
    }

    button[name="service-case-creation-disabled-btn"] {
        opacity: 0.4;
    }
}

.ux-tile-head {
    align-items: flex-start;
    display: flex;

    &__icon {
        width: 27px;
        align-items: center;
        display: flex;

        .ux-iws-discontinuation-icon {
            margin-left: 8px;
        }

        .ux-iws-discontinuation-tooltip {
            display: block;
        }
    }

    &__text {
        width: calc(100% - 27px);
        display: flex;
        flex-direction: column;
    }

    &__title {
        @include text-overflow(ellipsis);
    }

    &__description {
        align-items: center;
        display: flex;
        justify-content: flex-start;
    }

    &__status {
        align-items: center;
        display: flex;
        justify-content: flex-start;

        ux-iws-production-status,
        ux-w-status,
        ux-iws-status-label {
            margin-top: 5px;
            @include text-overflow(ellipsis);
            display: inline-block;
        }
    }
}
